import template from './page.grey-list.html';
import tcGreyListItem from './list-item/grey-list.list-item';
export default angular
  .module(
    'doxy.realtime.components.teleconsent.action.document.page.grey-list',
    [tcGreyListItem]
  )
  .component('tcGreyList', {
    //tc-grey-list
    template,
    bindings: {
      element: '<',
    },
    controller: function () {
      this.$onInit = function() {
        if (this.element) {
          this.element.listType = this.element.listType || 'ul';
        } else {
          console.warn('GreyList: element not available');
        }
      };
    },
  }).name;
